(() => {
  const init = () => {
    const hero = document.querySelector('.vr-hero');
    const heading = hero?.querySelector('.vr-hero-copy h1');
    const form = hero?.querySelector('.vr-hero-search');
    const button = form?.querySelector('button[type="submit"]');
    if (!heading || !form || !button) return;
    const align = () => {
      if (!window.matchMedia('(min-width:990px)').matches) {
        form.style.removeProperty('width');
        return;
      }
      const range = document.createRange();
      range.selectNodeContents(heading);
      const lines = [...range.getClientRects()].filter(rect => rect.width > 0);
      const end = lines[lines.length - 1]?.right;
      if (!end) return;
      const padding = parseFloat(getComputedStyle(form).paddingRight) || 0;
      const width = end + 12 + button.getBoundingClientRect().width + padding - form.getBoundingClientRect().left;
      form.style.width = `${Math.round(width * 100) / 100}px`;
    };
    align();
    document.fonts?.ready.then(align);
    window.addEventListener('resize', align, { passive: true });
    document.addEventListener('shopify:section:load', align);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
